import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/comparisons")({
  component: ComparisonsLayout,
});

function ComparisonsLayout() {
  return (
    <Outlet />
  );
}
